import { CRUD_TYPE_ROUTE } from './constants';
import http from '../../../utils/httpService';

/**
 *
 * @param quizLocalizationId
 */
export const requestTypeCreation = ( { quizLocalizationId } ) => {
    const body = {
        title: '',
        description: '',
        image_copyright: '',
        images: { imageMobile: '', imageDesktop: '' },
        quiz_localization_id: quizLocalizationId
    };
    return http.request( CRUD_TYPE_ROUTE, 'POST', body );
};

/**
 *
 * @param typeId
 * @param title
 * @param button
 * @param url_image
 * @param description
 * @param images
 */
export const requestTypeUpdate = ( { typeId, title, button, url_image, description, image_copyright, images } ) => {
    const body = {
        title,
        description,
        button,
        url_image,
        image_copyright,
        images: { ...images },
    };
    return http.request( CRUD_TYPE_ROUTE + '/' +  typeId, 'PUT', body );
};

/**
 *
 * @param typeId
 */
export const requestTypeDelete = ( { typeId } ) => {
    return http.request( CRUD_TYPE_ROUTE + '/' + typeId, 'DELETE' );
};

